import React, {Component} from 'react'
import moment from "moment/moment"
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import LoadingButton from "../LoadingButton";
import ProjectFeeRateInput from "./ProjectFeeRateInput";

import removeFeeRatesMutation from '../../../queries/server/mutations/remove_project_fee_rate'
import editProjectLocalMutation from '../../../queries/client_side/mutations/edit_project'

export default class ProjectFeeRateListItem extends Component {

    state = {
        editing: false
    }

    render() {

        const {project_id, active_from_date, hourly_rate} = this.props
        const {editing} = this.state

        if (editing) return (
            <div className="d-flex border-bottom pt-2 pb-2" style={{flex: 1}}>
                <ProjectFeeRateInput
                    onSaved={() => this.setState({editing: false})}
                    onCancel={() => this.setState({editing: false})}
                    {...this.props}
                    successMessage="Fee Rate Updated"
                />
            </div>
        )

        return (
            <div className="d-flex flex-row align-items-center justify-content-between border-bottom pt-2 pb-2">
                <p className="font-weight-light p-0 m-0 pl-2" style={{flex: 1}}><strong>Active
                    From:</strong> {moment(active_from_date).format('Do MMM YY')} - £{hourly_rate}</p>
                <LoadingButton
                    icon="edit"
                    loading={false}
                    size="sm"
                    color="warning"
                    className="square-btn mr-1"
                    onClick={() => this.setState({editing: true})}
                />
                <Mutation mutation={removeFeeRatesMutation}>
                    {(removeFeeRatesMutationFunc, {loading}) => (
                        <Mutation mutation={editProjectLocalMutation}>
                            {(editProjectLocalMutationFunc) => (
                                <LoadingButton
                                    icon="trash-alt"
                                    loading={loading}
                                    size="sm"
                                    color="danger"
                                    className="square-btn"
                                    onClick={() => {
                                        removeFeeRatesMutationFunc({variables: {project_id, dates: [active_from_date]}})
                                            .then(({data}) => {
                                                editProjectLocalMutationFunc({variables: {data: data.removeProjectFeeRates}})
                                                toast.success('Fee Rate Removed', {autoClose: 2000})
                                            })
                                            .catch(e => toast.success(e.message, {autoClose: false}))
                                    }}
                                />
                            )}

                        </Mutation>
                    )}

                </Mutation>
            </div>
        )
    }
}

ProjectFeeRateListItem.propTypes = {
    project_id: PropTypes.string.isRequired,
    active_from_date: PropTypes.string,
    hourly_rate: PropTypes.number
}